var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avatar)?_c('img',{staticClass:"image",attrs:{"src":_vm.avatar,"alt":"Аватар"},on:{"error":function (e) { return (e.target.src = _vm.defaultProfile_); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }